import { useContext } from 'react'

import { AuthHydrationContext } from '../store'

/**
 * Whether the app has completed the first client layout pass under StateProvider.
 * Use this before branching UI on `hasSessionToken` (or similar) so SSR HTML and
 * the initial hydrate tree stay aligned — sessionStorage is unavailable during SSR.
 *
 * @returns {boolean}
 */
export const useAuthHydrationReady = () => useContext(AuthHydrationContext)
